import React from 'react';
import { Buscador, BuscadorProps } from './buscador/Buscador';
import styles from './HeaderBusca.module.scss';

interface HeaderBuscaProps {
  buscadorProps?: Partial<BuscadorProps>;

  showFilter?: boolean;
  showOrder?: boolean;
  filterCount?: number;
  orderLabel?: string;
  onFilterClick?: () => void;
  onOrderClick?: () => void;
}

export const HeaderBusca: React.FC<HeaderBuscaProps> = ({
  buscadorProps,

  showFilter = true,
  showOrder = true,
  filterCount = 0,
  orderLabel = 'Ordenar A-Z',
  onFilterClick,
  onOrderClick,
}) => {
  return (
    <div className={styles.page}>
        <div className={styles.containerBusca} >
          <Buscador {...buscadorProps} />
        </div>
      <div className={styles.actions}>
        {showFilter && (
          <button onClick={onFilterClick} className={styles.btnFiltro}>
            Filtrar ({filterCount})
          </button>
        )}

        {showOrder && (
          <button onClick={onOrderClick} className={styles.btnOrdenar}>
            {orderLabel}
          </button>
        )}
      </div>
    </div>
  );
};